export const approveBidEmailTemplate = (username, category) => `
Dear ${username},

Congratulations! Your bid has been approved for the category "${category}" in the FHP platform.

Here are the next steps:
  - Ensure that payment of the bid price is completed by the 20th as well.

Important Dates:
  - Submission Deadline: 20th of this month
  - Final Review: You will be notified by the 24th of this month if your payment has been received and the ad text/link is acceptable.

If payment or ad text/link is not provided or acceptable, you will have 24 hours to correct it, or you may forfeit your application fee, and the next vendor in line will take your spot.

All decisions made by FHP are final and non-reviewable.

Thank you for your participation,
FHP Team
`;

export const reservedBidEmailTemplate = (username, category) => `
Dear ${username},

Your bid has been reserved for the category "${category}" in the FHP platform.

This means your bid is now in a reserved state. If other bids encounter issues or additional bids are needed, yours will be considered as a reserve option.

Here are the next steps:
  - Ensure that payments are prepared in case we need to move forward with your bid.

Important Notes:
  - You will be notified if your bid is moved from reserved to approved or if any further action is required on your part.

All decisions made by FHP are final and non-reviewable.

Thank you for your participation,
FHP Team
`;

export const revertBidEmailTemplate = (username, category) => `
Dear ${username},

We regret to inform you that your bid for the category "${category}" on the FHP platform has been reverted to a pending state.

This decision has been made due to recent updates or changes in our review process. Your bid will remain in the pending status until further notice.

Here are the next steps:
  - Please review any pending requirements or updates that may be needed for your bid.

Important Notes:
  - You will be notified of any further actions or decisions regarding your bid.

We appreciate your understanding and continued interest in the FHP platform.

Thank you for your participation,
FHP Team
`;

export const rejectBidEmailTemplate = (username, category) => `
Dear ${username},

Thank you for your interest in the category "${category}" on the FHP platform.

We regret to inform you that your bid has not been selected for this round. We appreciate the effort you put into your submission and encourage you to participate in future opportunities.

Thank you for your understanding and participation.

Best regards,
FHP Team
`;
